import { render, staticRenderFns } from "./AddWarehouseLocationModal.vue?vue&type=template&id=3c487842"
import script from "./AddWarehouseLocationModal.vue?vue&type=script&lang=js"
export * from "./AddWarehouseLocationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports